export const COUNTDOWN_MAX_SECONDS = 45;
export const COUNTDOWN_WARNING_SECONDS = 10;

export function normalizeCountdown(value) {
  return Math.max(0, Number(value) || 0);
}

export function countdownProgress(value, maximum = COUNTDOWN_MAX_SECONDS) {
  const safeMaximum = Math.max(1, Number(maximum) || COUNTDOWN_MAX_SECONDS);
  return Math.min(1, normalizeCountdown(value) / safeMaximum);
}

export function isCriticalCountdown(value) {
  const seconds = normalizeCountdown(value);
  return seconds > 0 && seconds <= COUNTDOWN_WARNING_SECONDS;
}

export function countdownArcDegrees(value) {
  return countdownProgress(value) * 360;
}

export function countdownCursorAngle(value) {
  return -90 - countdownArcDegrees(value);
}
